class PaginatedReportGenerator {
    constructor(apiClient) {
        this.apiClient = apiClient;
        this.reportEndpoint = 'https://paginated-report-service.rdrive.io/api/report';
        this.supportedFormats = [
            'PDF',
            'EXCELOPENXML',
            'WORDOPENXML',
            'CSV',
            'XML',
            'HTML5',
            'IMAGE'
        ];
    }

    async generateReport({
        reportName,
        fileFormat = 'PDF',
        parameters = [],
        data = {
            ItemsLatestData: [],
            ProjectInfo: [],
            Translation: []
        }
    }) {
        try {
            const normalizedFormat = fileFormat.toUpperCase();
            if (!this.supportedFormats.includes(normalizedFormat)) {
                throw new Error(`Unsupported file format. Supported formats are: ${this.supportedFormats.join(', ')}`);
            }

            const requestBody = {
                reportName,
                fileFormat: normalizedFormat,
                parameters,
                data
            };

            // First POST request to get the token
            const tokenResponse = await fetch(this.reportEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestBody)
            });

            if (!tokenResponse.ok) {
                throw new Error(`HTTP error! status: ${tokenResponse.status}`);
            }

            const { token } = await tokenResponse.json();

            // Create the download URL
            const downloadUrl = `${this.reportEndpoint}?download=true&token=${token}`;

            // Create an invisible iframe for download
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.src = downloadUrl;
            
            // Add necessary attributes for security policy
            iframe.setAttribute('sandbox', 'allow-downloads allow-scripts allow-same-origin');
            iframe.setAttribute('allow', 'downloads');
            
            // Handle cleanup
            iframe.onload = () => {
                setTimeout(() => {
                    document.body.removeChild(iframe);
                }, 5000); // Remove iframe after 5 seconds
            };

            document.body.appendChild(iframe);

        } catch (error) {
            console.error('Error generating report:', error);
            throw new Error('Failed to generate report: ' + error.message);
        }
    }
}

export default PaginatedReportGenerator;